export default "__VITE_ASSET__Bec_id1c__"